<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/5_Itinerari-esperienze/5b_cicloturismo-Lago-Cecita_Sila.jpg">
<div class="content">
    <h1>Calabria</h1>
    <h3>Cicloturismo</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Esperienze e itinerari</a> > <a class="active">Cicloturismo</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            Una delle infrastrutture turistiche più importanti della Calabria interna è la Ciclovia dei Parchi che offre agli appassionati delle 
            due ruote ben 545 Km di autentica scoperta.
            <br>
            <br>
            Paesi arroccati, boschi e foreste fittissime, laghi in quota, colline assolate, faggete vetuste, luoghi e 
            geositi Patrimonio Unesco, musei diffusi, culture e dialetti, tradizioni agroalimentari ed enogastronomiche irripetibili altrove, 
            sono solo alcuni degli ingredienti che la Ciclovia offre agli appassionati delle due ruote che amano entrare in relazione con i luoghi e 
            vivere appieno l’esperienza del viaggio.
            <br>
            <br>
            Da Laino Borgo, nel cuore del Parco Nazionale del Pollino, fino a Gambarie in Aspromonte, attraversando il Parco della Sila e quello delle 
            Serre calabresi, la Ciclovia corre lungo i crinali appenninici da cui volgendo lo sguardo ad est e ad ovest è frequente poter vedere il mare, 
            una suggestione unica che solo la Calabria può regalare e che culmina nell’ultimo tratto, la discesa vorticosa con approdo sullo splendido lungomare
             di Reggio Calabria, “il più bel chilometro d’Italia”, come ebbe a definirlo Gabriele D’Annunzio.
            <br>
            <br>
            Il percorso si sviluppa in dodici tappe, con un dislivello complessivo di 10.240 m che richiede gambe allenate ma che in cambio regala 
            emozioni uniche. Un tracciato che attrae cicloturisti da tutto il mondo che nel 2021 ha ricevuto l’Oscar Italiano del Cicloturismo e che da allora 
            continua la sua crescita in termini di servizi, attività e proposte turistiche confidando su un sito in cinque lingue - www.cicloviaparchicalabria.it - e 
            canali social molto seguiti.
        </p>
    </div>
</div>
<!-- <br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div> -->
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>